import { Row, Container } from 'react-bootstrap';
import { SchoolWork } from './SchoolWork';
import { StrokeDivider } from './StrokeDivider';
import stroke1 from '../assets/img/stroke1.svg';
import stroke2 from '../assets/img/stroke2.svg';
import workschool from '../assets/contents/workschool.json';
import tudelft from '../assets/img/tudelft.png';
import google from '../assets/img/google.png';
import ib from '../assets/img/ib.svg';
import sbi from '../assets/img/sbi.png';
import meirEitan from '../assets/img/meir-eitan.png';

const education = [
    { ...workschool[0], imagepath: tudelft },
    { ...workschool[1], imagepath: ib, logoClassName: 'logo-padded' },
];

const work = [
    { ...workschool[2], imagepath: tudelft },
    { ...workschool[3], imagepath: sbi },
    { ...workschool[4], imagepath: google },
    { ...workschool[5], imagepath: meirEitan },
];

export const EducationWork = () => (
    <div className="education-work">
        <section id="education">
            <Container className="text-start">
                <Row>
                    <div className="section-header">education</div>
                </Row>
                <Row className="d-flex justify-content-end">
                    <SchoolWork {...education[0]} />
                </Row>
                <StrokeDivider src={stroke2} flipped />
                <Row>
                    <SchoolWork {...education[1]} />
                </Row>
            </Container>
        </section>
        <section id="work">
            <Container className="text-start">
                <Row>
                    <div className="section-header">work</div>
                </Row>
                <Row>
                    <SchoolWork {...work[0]} />
                </Row>
                <StrokeDivider src={stroke2} />
                <Row className="d-flex justify-content-end">
                    <SchoolWork {...work[1]} />
                </Row>
                <StrokeDivider src={stroke1} flipped />
                <Row>
                    <SchoolWork {...work[2]} />
                </Row>
                <StrokeDivider src={stroke2} />
                <Row className="d-flex justify-content-end">
                    <SchoolWork {...work[3]} />
                </Row>
            </Container>
        </section>
    </div>
);
